import { INSTANCE } from './endpoint';

const getToken = () => `Bearer ${localStorage.getItem('token')}`;
const headers = () => ({ Authorization: getToken() });

export const getCommunityOverviewApi = (communityId: string, startDate: string, endDate: string) =>
  INSTANCE.get(`/v1/analytics/community/${communityId}/overview`, {
    headers: headers(),
    params: { startDate, endDate },
  }).then((res) => res.data);

export const getChannelBreakdownApi = (communityId: string, startDate: string, endDate: string) =>
  INSTANCE.get(`/v1/analytics/community/${communityId}/channels`, {
    headers: headers(),
    params: { startDate, endDate },
  }).then((res) => res.data);

export const getUserActivityApi = (communityId: string, startDate: string, endDate: string, limit?: number) =>
  INSTANCE.get(`/v1/analytics/community/${communityId}/users`, {
    headers: headers(),
    params: { startDate, endDate, limit },
  }).then((res) => res.data);

export const getChannelDetailApi = (channelId: string, startDate: string, endDate: string, communityIdentifier?: string) =>
  INSTANCE.get(`/v1/analytics/channel/${channelId}/detail`, {
    headers: headers(),
    params: { startDate, endDate, communityIdentifier },
  }).then((res) => res.data);

export const getUserDetailApi = (userId: string, communityIdentifier: string, startDate: string, endDate: string) =>
  INSTANCE.get(`/v1/analytics/user/${userId}/activity`, {
    headers: headers(),
    params: { startDate, endDate, communityIdentifier },
  }).then((res) => res.data);
